<template>
  <div>
    <a-drawer
      :width="1200"
      :visible="showCreateForm"
      :body-style="{ paddingBottom: '15px', paddingTop: '15px' }"
      class="create-kuaishou-ad-page"
      @close="close"
    >
      <a-form-model ref="form" :model="model" :rules="rules" >
        <a-spin :spinning="loading" tip="Loading..." size="large" />

        <a-steps type="navigation" size="small" :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>

        <div class="step" v-if="current === 0">
          <a-form-model-item label="原始账户" prop="advertiser_id">
            <adv-select v-model="model.advertiser_id" :max-tag-count="1" :type="media" :disabled="true"/>
          </a-form-model-item>

          <a-form-model-item v-if="[3].includes(params.platform_app_type)" label="付费类型" prop="pay_type">
            <a-radio-group :default-value="1" button-style="solid" v-model="model.pay_type" @change="changePayType(model.pay_type)">
              <a-radio-button :value="1">
                付费
              </a-radio-button>
              <a-radio-button :value="2">
                免费
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
    
          <a-form-model-item label="媒体主体" prop="media_corporations">
            <a-select
              show-search
              placeholder=""
              v-model="model.media_corporations"
              option-filter-prop="children"
              mode="multiple" 
            >
              <a-select-option :value="item" v-for="item in media_corporations" :key="item">
                {{ item }}<span v-if="corporationCountMap[item]">（{{ corporationCountMap[item] }}）</span>
              </a-select-option>
            </a-select>
            <a-button @click="showBatchModal = true" type="dashed">批量导入</a-button>
            <a-modal
              title="批量导入媒体主体"
              :visible="showBatchModal"
              @ok="handleBatchImport"
              @cancel="showBatchModal = false"
              :confirmLoading="batchLoading"
            >
              <a-textarea
                v-model="batchInput"
                placeholder="请输入媒体主体名称，支持换行、逗号（英文）、空格分隔。"
                :rows="6"
              />
              <div style="margin-top: 8px; color: #999;">
                系统将自动匹配已有媒体主体，未匹配到的将被忽略。
              </div>
            </a-modal>
          </a-form-model-item>

          <a-form-model-item prop="num" label="主体广告主数量" help="每个主体要抓取的广告主数量，最大不能超过5个">
            <a-input-number :min="1" :max="5" :precision="0" v-model="model.num"/>
          </a-form-model-item>

          <a-form-model-item prop="remark" label="统一备注" help="">
            <a-input v-model="model.remark"/>
          </a-form-model-item>

          <a-form-model-item label="绑定优化师" prop="worker_id">
              <a-select placeholder="请选择" :default-value="model.worker_id" show-search option-filter-prop="children"
                        v-model="model.worker_id">
                  <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                      {{ worker.name }}
                  </a-select-option>
              </a-select>
          </a-form-model-item>


          <a-form-model-item v-if="[1,2].includes(params.platform_app_type)" label="推广链接名称" prop="pt_name" help="推广链名称只能输入汉字、字母、数字和减号">
            <a-input v-model="model.pt_name"/>
          </a-form-model-item>

        </div>

        <div class="step" v-if="current === 1">
            <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
              <a-tabs :default-active-key="0"  size="small" tabPosition="left"  :style="{ height: '300px' }">
                <a-tab-pane  :tab="name" v-for="(advertiser,name, index) in advertisers" :key="index" >
                  <a-form-model-item label="广告主">
                    <adv-select v-model="advertisers[name]" :max-tag-count="model.num" :type="media" :is-new="1" :media-corporation="name"/>
                  </a-form-model-item> 
                </a-tab-pane>
              </a-tabs>
            </a-form-model-item>
        </div>

        <div class="step" v-if="current === 2">
          <a-result
            status="success"
            title="提交成功"
            sub-title="该任务为异步执行，请稍后查看状态"
            v-if="!task.id"
          >
          <!-- <a-button v-if="current > 0" @click="prev">上一步</a-button> -->
          </a-result>

          <a-tabs :default-active-key="0"  size="small" tabPosition="left"  :style="{ minHeight: '300px' }" v-else>
            <a-tab-pane v-for="(advertisers,name, index) in task.results" :key="index" >

              <template #tab>
                <span :style="{ color: advertisers.some(item => item.status === 2) ? 'red' : 'inherit' }">
                  {{ name }}
                </span>
              </template>

              <a-list bordered v-for="(item, index) in advertisers" :key="index" style="margin-bottom:20px">
              
                <a-steps :current="item.step-1" style="padding:10px;" :status="item.message ? 'error':'process'" size="small">
                  <a-step title="等待" :description="item.step == 0 ? '等待任务开始执行':''" v-if="item.step == 0"/>
                  <template v-else>
                    <a-step title="绑定投手" :description="item.message && item.message.step1 ? item.message.step1 : (item.step>=1?'成功绑定广告主':'') " />
                    <a-step title="修改头像备注" :description="item.message && item.message.step2 ? item.message.step2 : (item.step>=2?'成功修改头像备注':'') " />
                    <a-step v-if="[1,2].includes(params.platform_app_type)" title="搭建推广链接" :description="item.message && item.message.step3 ? item.message.step3 : (item.step>=3?'成功搭建推广链接':'') " />
                    <a-step v-if="[1,2].includes(params.platform_app_type)" title="搭建小程序" :description="item.message && item.message.step4 ? item.message.step4 :  (item.step>=4?'成功搭建小程序':'') " />
                    <a-step v-if="[1,2].includes(params.platform_app_type)" title="搭建事件资产" :description="item.message && item.message.step5 ? item.message.step5 :  (item.step>=5?'成功搭建事件资产':'') " />
                  </template>
                </a-steps>

                <div slot="header">
                  <span @click="copy(item.advertiser_name)">{{ item.advertiser_name }}</span>
                  <a-divider type="vertical"/>
                  <a-button type="danger" size="small" v-if="item.status == 2"  @click="retry(item)" >重试</a-button>
                </div>
              </a-list>

            </a-tab-pane>
          </a-tabs>
 
        </div>

        <div class="steps-action" v-if="show_type != 2">
          <a-space class="button-group">
            <template v-if="current < 2">
              <a-button v-if="current === 0" @click="close">取消</a-button>
              <a-button v-if="current > 0" @click="prev">上一步</a-button>
              <a-button v-if="current < steps.length - 2" type="primary" @click="next">下一步</a-button>
              <a-button v-if="current === steps.length - 2" type="primary" @click="submit">提交</a-button>
            </template>

            <template v-if="current === steps.length - 1">
              <a-button :loading="loading" :disabled="loading" @click="close">
                {{ loading ? '任务执行中' : '确认并关闭' }}
              </a-button>

              <a-button  type="primary" @click="restart"  v-if="task && task.status == 1">
                  重新开始铺户
              </a-button>
              <a-button type="primary" v-else @click="createAdvertiserTask()">
                  继续铺户
              </a-button>
            </template>
          </a-space>

        </div>
      </a-form-model>
    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'AdvertiserTask';
</style>

<script>
import AdvertiserTask from './AdvertiserTask'
export default AdvertiserTask
</script>
